import { useTLang } from 'intl/intl';

import type { Props } from '../substitutionFlowStatusChip.model';

export function useSubstitutionFlowStatusChipLang(
  props: Pick<Props, 'status'>,
) {
  const { status } = props;

  const langCheckChat = useTLang({ id: 'substitutionFlow.028' });
  const label = {
    awaiting: useTLang({ id: 'substitutionFlow.026' }),
    timeout: useTLang({ id: 'substitutionFlow.027' }),
    another: langCheckChat,
    accepted: useTLang({ id: 'substitutionFlow.029' }),
    refused: useTLang({ id: 'substitutionFlow.030' }),
    chat: langCheckChat,
  };

  return {
    label: label[status ?? 'awaiting'],
  };
}
